<template>
  <div class="hero">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 521.15 521.15">
      <g data-name="Belbouk">
        <polygon class="belbouk"
          points="481.06 300.68 461.01 320.72 440.97 340.76 420.93 360.81 400.88 340.76 380.84 320.72 360.79 340.76 340.75 360.81 320.71 380.85 300.66 400.9 320.71 420.94 340.75 440.98 320.71 461.03 300.66 481.07 280.62 501.12 260.57 521.16 240.53 501.12 220.49 481.07 200.44 461.03 180.4 440.98 160.36 420.94 140.31 400.9 160.36 380.85 180.4 400.9 200.44 420.94 220.49 440.98 240.53 461.03 260.57 481.07 280.62 461.03 300.66 440.98 280.62 420.94 260.57 440.98 240.53 420.94 220.49 400.9 240.53 380.85 260.57 360.81 280.62 380.85 300.66 360.81 320.71 340.76 340.75 320.72 360.79 300.68 340.75 280.63 320.71 260.59 300.66 240.54 320.71 220.5 340.75 240.54 360.79 260.59 380.84 280.63 400.88 300.68 420.93 320.72 440.97 300.68 420.93 280.63 400.88 260.59 420.93 240.54 440.97 220.5 461.01 200.46 481.06 220.5 461.01 240.54 440.97 260.59 481.06 300.68" />
        <polygon class="belbouk"
          points="400.88 220.5 380.84 240.54 360.79 220.5 340.75 200.46 320.71 180.41 300.66 200.46 280.62 220.5 260.57 240.54 240.53 260.59 260.57 280.63 280.62 260.59 300.66 280.63 320.71 300.68 300.66 320.72 280.62 340.76 260.57 320.72 240.53 300.68 220.49 280.63 200.44 260.59 220.49 240.54 240.53 220.5 260.57 200.46 280.62 180.41 300.66 160.37 320.71 140.32 340.75 160.37 400.88 220.5" />
        <polygon class="ayyoub"
          points="160.53 300.5 180.57 320.54 160.53 340.59 140.49 360.63 120.44 340.59 140.49 320.54 120.44 300.5 140.49 280.46 160.53 260.41 180.57 280.46 160.53 300.5" />
        <polygon class="ayyoub"
          points="120.27 340.76 100.22 360.81 80.18 340.76 60.14 320.72 40.09 300.68 20.05 280.63 0 260.59 20.05 240.54 40.09 260.59 60.14 280.63 80.18 300.68 100.22 320.72 120.27 340.76" />
        <polygon class="ayyoub"
          points="260.57 160.37 240.53 180.41 220.49 160.37 200.44 140.32 180.4 120.28 140.31 160.37 160.36 180.41 180.4 160.37 200.44 180.41 220.49 200.46 200.44 220.5 180.4 240.54 160.36 220.5 140.31 240.54 120.27 260.59 100.22 280.63 80.18 260.59 100.22 240.54 120.27 220.5 140.31 200.46 120.27 180.41 100.22 160.37 120.27 140.32 140.31 120.28 160.36 100.24 180.4 80.19 200.44 100.24 220.49 120.28 240.53 140.32 260.57 160.37" />
        <polygon class="ayyoub"
          points="440.97 180.41 420.93 200.46 400.88 180.41 380.84 160.37 360.79 140.32 340.75 120.28 300.66 80.19 280.62 100.24 260.57 120.28 240.53 100.24 220.49 80.19 200.44 60.15 220.49 40.1 240.53 60.15 260.57 80.19 280.62 60.15 300.66 40.1 320.71 60.15 340.75 80.19 360.79 100.24 380.84 120.28 400.88 140.32 420.93 160.37 440.97 180.41" />
        <polygon class="ayyoub"
          points="100.22 200.46 80.18 220.5 60.14 240.54 40.09 220.5 60.14 200.46 80.18 180.41 100.22 200.46" />
        <polygon class="belbouk"
          points="240.53 340.76 220.49 360.81 200.44 380.85 180.4 360.81 200.44 340.76 220.49 320.72 240.53 340.76" />
        <path class="ayyoub"
          d="M277.1,16.53c-3.77-.28-4.59-1.6-5.89-.91-6.35,3.35-8.48,3.41-9.15-1-.5-3.28,1.5-6.8,3.32-9.8L260.58,0l-20,20.05,20,20,20-20Z" />
        <path class="ayyoub"
          d="M256.75,14.48c.67,4.43,10.21,8.66,16.56,5.31a11.93,11.93,0,0,0,3.79-3.26L265.38,4.8C260.45,6.76,256.25,11.2,256.75,14.48Z" />
        <path class="belbouk"
          d="M369.46,397.25c-.64-5.41-1.2-6,.07-7.67l-8.73-8.74-20.05,20,20.05,20.05,20-20.05-1.78-1.78C371.77,398.51,370.22,403.73,369.46,397.25Z" />
        <path class="belbouk"
          d="M365.83,399c.76,6.48,8.26,3.36,13.23.14l-9.53-9.52C366.37,391,365.19,393.55,365.83,399Z" />
        <path class="belbouk"
          d="M515.34,254.76a12.39,12.39,0,0,0-3.9.08c-1.62,2,.45.82-3.87.52s.58,1.14-.92-3.24c-1.17-3.43-.37-2.37,1.56-4.49l-7.1-7.1-20.05,20,20.05,20,20-20Z" />
        <path class="belbouk"
          d="M504.37,251.48c1.5,4.38-2,6.12,2.28,6.42s6.78-.72,8.4-2.76l.29-.38-7.13-7.13C504.79,248,503.2,248.05,504.37,251.48Z" />
      </g>
    </svg>
    <h1>BELBOUK Ayyoub</h1>
    <h3>HI, I AM A <span class="typed"></span></h3>
  </div>
</template>

<script>
import Typed from 'typed.js';

export default {
  name: "Hero",
  mounted() {
    new Typed('.typed', {
      strings: ['WEB DEVELOPER', 'FREELANCER', 'WEB DESIGNER'],
      typeSpeed: 60,
      backSpeed: 60,
      loop: true,
      loopCount: Infinity,
    });
  }
};
</script>

<style scoped>
h1,
h3 {
  color: white !important;
}

svg {
  fill: #fdae57;
}

.belbouk {
  animation: shadow 1s ease infinite;
  animation-delay: 0.5s;
}

.ayyoub {
  animation: shadow 1s ease infinite;
}

@keyframes shadow {

  0%,
  100% {
    transform: scale(0.99);
  }

  50% {
    transform: scale(1);
  }
}
</style>
